import lonelyhouse from '../assets/lonelyhouse.jpeg';
import './Ifwyou.css';
import React from 'react';
import ripmeopen from '../assets/ripmeopen.png'


function Ifwyou() {

  return (
    <>
    <div className="ifwyou-page">
        <img src={ripmeopen} alt="body" className="ripme-image" />
        <p className="article-text">
          i'm trying to sleep, i just want to sleep. i should sleep at my place tonight. and drink tea. and take a nice wonderful bath and listen to music.
  </p>
  </div> 
  </> 


  );
}
 export default Ifwyou;